export function online(state, status) {
  state.online = status
}

export function isApiKeyValid(state, isApiKeyValid) {
  state.isApiKeyValid = isApiKeyValid
}
